import { render, staticRenderFns } from "./fixedAssetsDetail.vue?vue&type=template&id=e95108c2&scoped=true&"
import script from "./fixedAssetsDetail.vue?vue&type=script&lang=js&"
export * from "./fixedAssetsDetail.vue?vue&type=script&lang=js&"
import style0 from "./fixedAssetsDetail.vue?vue&type=style&index=0&id=e95108c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95108c2",
  null
  
)

export default component.exports